import { DownloadOutlined } from '@ant-design/icons';
import TaggedTooltipButton, { TaggedTooltipButtonOwnProps } from '../TaggedTooltipButton';

const TaggedDownloadButton = (props:TaggedTooltipButtonOwnProps) => {
  return (
    <TaggedTooltipButton {...props} icon={<DownloadOutlined />} type="primary" />
  );
};

export default TaggedDownloadButton;
